/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import LeaderboardListItem from './LeaderboardListItem';
export default class LeaderboardItemList extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.adjustCountWidth();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.adjustCountWidth();
  }
  adjustCountWidth() {
    ['.LeaderboardItemList .LeaderboardListItem-count', '.LeaderboardItemList .LeaderboardListItem-position'].forEach(selector => {
      let largestWidth = 0;
      $(selector).each((i, el) => {
        const width = el.clientWidth;
        if (width > largestWidth) {
          largestWidth = width;
        }
      });
      $(selector).css('min-width', `${largestWidth}px`);
    });
  }
  view() {
    const state = app.leaderboard;
    if (state.isEmpty() || state.isInitialLoading()) {
      return null;
    }
    return m("ul", {
      className: "LeaderboardItemList"
    }, state.getAllItems().map((user, i) => m("li", {
      className: "LeaderboardItemList-item",
      key: user.id(),
      "data-id": user.id()
    }, this.listItem(user, i + 4))));
  }
  listItem(user, position) {
    return m(LeaderboardListItem, {
      user: user,
      value: app.leaderboard.scoreOf(user),
      position: position
    });
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/leaderboards/components/LeaderboardItemList', LeaderboardItemList);